import styles from '../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div className={styles.template_preview_container}>
      <h2>Business Profile Overview</h2>
      <p>
        Your Business Profile is the single source of truth for your organisation’s key governance
        information. It should be the one place where your business details, official records, and
        important documents are securely stored and kept up to date.
      </p>
      <p>This section allows you to manage:</p>
      <ul>
        <li>
          <strong>Business details:&nbsp;</strong>Store your official business name, registration
          numbers, contact email, phone number, and tax or regulatory documents and identifiers.
        </li>
        <li>
          <strong>Organisation contacts:&nbsp;</strong>Add or update key individuals such as
          Directors, Secretaries, or Accountants for easy reference and consistency across your
          records.
        </li>
        <li>
          <strong>Document storage:&nbsp;</strong>Upload and manage critical governance documents
          such as company deeds, letters, shareholder communications, and more.
        </li>
        <li>
          <strong>Notes:&nbsp;</strong>Record internal updates, decisions, or context relating to
          your business profile.
        </li>
        <li>
          <strong>Data sync:&nbsp;</strong>Profile data is integrated across the platform to support
          your workflows, records and administrative consistency.
        </li>
      </ul>
      <p>
        <strong>Tip:&nbsp;</strong>Use this profile as your company’s central governance hub. Review
        and update regularly to ensure accuracy and compliance.
      </p>
    </div>
  );
};

export default Preview;
